import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';
import { colours } from 'themes/default';

const TextInput = styled('input')`
  width: ${(props) => props.width || 'initial'};
  font-size: 16px;
  border-radius: 5px;
  background-color: ${(props) => (props.disabled ? colours.Greyscale.SilverGrey : colours.Greyscale.White)};
  color: ${colours.Shades.BlueShade40};
  border: 1px solid ${(props) => (props.disabled ? colours.Greyscale.SilverGrey : colours.Greyscale.MistGrey)};
  padding: 0.6em 1.4em 0.5em 0.8em;
  box-sizing: border-box;

  &[type='date'] {
    padding: 0.4em 1.4em 0.3em 0.8em;
  }

  ::placeholder {
    color: ${colours.Greyscale.SmokeGrey};
  }

  ${ifProp(
    'linkable',
    css`
      cursor: pointer;
      text-decoration: underline;
    `
  )};
`;

export default TextInput;
